module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3d3b8fce985f973f14d3ebef6627a7f1.png";